import React, { useCallback, useEffect, useRef, useState } from "react";
import ContentHeader from "../../ShareElements/ContentHeader/ContentHeader";
import UploadZone from "./Components/UploadZone";
import Circle from "../../../../../Assets/Images/sm-Circle.svg";
import { formatDate, translateText } from "../../../../../Helper_functions";
import SearchInput from "../../ShareElements/SearchInput/SearchInput";
import UploadWidget from "./Components/UploadWidget";
import Rotator from "../../../../../Assets/Images/ButtonLoadingIcon.svg";
import Select from "../../ShareElements/Select/Select";
import { Config } from "../../../../../Config";
import axios from "axios";
import FormEmptyState from "../../ShareElements/EmptyState/FormEmptyState";
import Alert from "../../ShareElements/Alert/Alert";

const Assistify = (props) => {
  const TimerRef = useRef(null);
  const [SizeLimits, setSizeLimits] = useState({
    zipFile: 200,
    otherFile: 100,
  });
  const [Files, setFiles] = useState([]);
  const [BinaryFiles, setBinaryFiles] = useState([]);
  const [SuccessfulUploads, setSuccessfulUploads] = useState(0);
  const [PageInfo, setPageInfo] = useState({});
  const [Pages, setPages] = useState([1]);
  const [SizeOptions] = useState([
    { name: 5, id: 5 },
    { name: 10, id: 10 },
    { name: 15, id: 15 },
    { name: 25, id: 25 },
  ]);
  const [SelectedSize, setSelectedSize] = useState(5);
  const [TotalElements, setTotalElements] = useState(0);
  const [ExtractInProgress, setExtractInProgress] = useState(false);
  const [ResIsEmpty, setResIsEmpty] = useState(false);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);
  const [FileToDelete, setFileToDelete] = useState();
  const [AllFilesCount, setAllFilesCount] = useState(0);
  const [UploadIsOngoing, setUploadIsOngoing] = useState(false);
  const [ActivePage, setActivePage] = useState(1);
  const [InitialLoadIsDone, setInitialLoadIsDone] = useState(false);
  const [CheckedItems, setCheckedItems] = useState([]);
  const [ModalIsOpen, setModalIsOpen] = useState(false);
  const [SelectIsActive, setSelectIsActive] = useState(false); // indicates wether select all or unselect all for checkboxes is active

  useEffect(() => {
    fetchHistory(true, 0, SelectedSize);
    fetchSizeLimits();
    fetchAllFilesStatus();
  }, []);

  const fetchSizeLimits = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/upload-limit",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setSizeLimits({
          otherFile: Res.data.assistityFileSizeLimitKb,
          zipFile: Res.data.assistityFileZipSizeLimitMb,
        });
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const uncheckAll = (Items) => {
    Items.map((Item) => {
      document.getElementById("checkbox-" + Item.id).checked = false;
    });
    setCheckedItems([]);
    setSelectIsActive(false);
  };

  const fetchHistory = (IsInitial, Start, Size) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/assistify/files/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        criteria: {
          fileNameLike: document.getElementById("search-input").value,
        },
        size: Size,
        sorts: [
          {
            direction: "DESC",
            fieldName: "updatedTime",
          },
        ],
        start: Start,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        createHistoryData(Res.data.results, Res.data.totalElements, Start);

        if (Res.data.results.length <= SelectedSize) {
          document.getElementById("end").innerHTML =
            Res.data.results.length + Start;
        }
        if (IsInitial) {
          setInitialLoadIsDone(true);
        }
        setTotalElements(Res.data.totalElements);
        if (!IsInitial && Res.data.results.length === 0) {
          setResIsEmpty(true);
        } else if (ResIsEmpty) {
          setResIsEmpty(false);
        }

        setSuccessfulUploads(Res.data.totalUploaded);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const clickActivePage = () => {
    Pages.map((Page) => {
      if (
        document.getElementById(Page + "-page-btn") &&
        document
          .getElementById(Page + "-page-btn")
          .classList.contains("active-page")
      ) {
        document.getElementById(Page + "-page-btn").click();
      }
    });
  };

  const fetchAllFilesStatus = useCallback(() => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/assistify/files/search",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        size: 1000,
        start: 0,
      },
    };
    axios(Req)
      .then((Res) => {
        setAllFilesCount(Res.data.totalElements);

        let ItemStatuses = [];
        Res.data.results.map((Item) => {
          ItemStatuses.push(Item.status);
        });
        if (ItemStatuses.includes("ANALYZING")) {
          setExtractInProgress(true);
          clickActivePage();
        } else {
          setExtractInProgress(false);
          clickActivePage();
        }

        setSuccessfulUploads(Res.data.totalUploaded);
      })
      .catch((Err) => {
        console.log(Err);
      });
  }, [ActivePage]);

  useEffect(() => {
    const IntervalId = setInterval(() => {
      if (window.location.pathname === "/home/assistify") {
        fetchAllFilesStatus(true);
      }
    }, 5000);

    return () => {
      clearInterval(IntervalId);
    };
  }, [fetchAllFilesStatus]);

  // Status values:
  //  WAITING_FOR_UPLOAD: The file has been successfully received and is waiting for uploading
  //  UPLOADING: The file is being uploaded to the storage server
  //  UPLOAD_FAILED: The file failed to upload to the storage server.
  //  UPLOADED: The file is successfully uploaded to the storage server
  //  MARK_FOR_DELETION: The file is marked for deletion
  //  ANALYZING: The file is being analyzed by the AI server
  //  ANALYZING_FAILED: The file is failed to analyze by the AI server
  //  ANALYZED: The file is successfully analyzed by the AI server
  //  DELETED: The file is successfully deleted

  // If it has sub-statuses:
  //  DUPLICATED_CONTENT: when the content is duplicated with other existing file
  //  INVALID_FILE_TYPE: when the file type is not supported
  //  FILE_SIZE_TOO_LARGE: when the file size exceed the max limit allowed
  //  Another upload/extract is in progress and a new one cannot be started at the time
  //  A server issue happened (e.g., sorry! Something went wrong.)
  const switchStatus = (Status) => {
    if (Status === "UPLOADED" || Status === "WAITING_FOR_UPLOAD") {
      return "success";
    } else if (Status === "UPLOADING" || Status === "ANALYZING") {
      return "loading";
    } else if (
      Status === "UPLOAD_FAILED" ||
      Status === "DUPLICATED_CONTENT" ||
      Status === "INVALID_FILE_TYPE" ||
      Status === "CONTAINS_ERROR_FILE" ||
      Status === "SERVER_ERROR" ||
      Status === "FILE_SIZE_TOO_LARGE" ||
      Status === "DELETION_FAILED"
    ) {
      return "failed";
    } else if (Status === "ANALYZING_FAILED") {
      return "uploaded-failed";
    } else if (Status === "ANALYZED") {
      return "uploaded-analyzed";
    }
  };

  const createHistoryData = (Items, TotalCount, Start) => {
    let HistoryItems = [];

    Items.map((Item) => {
      // new item in the history list
      let ItemToPush = {
        name: Item.fileName,
        updatedTime: new Date(Item.updatedTime).getTime(),
        size: Item.size,
        id: Item.id,
        type: "non-zip",
        status: switchStatus(Item.status),
        percentage: 100,
        ErrorMessage: Item.message,
        InfoMessage: "",
      };

      // checking file extension
      let FileName = Item.fileName;
      let IndexToSlice = FileName.length - 4;
      let Extention = FileName.slice(IndexToSlice, FileName.length);
      if (Extention === ".zip" || Extention === ".ZIP") {
        ItemToPush.type = "zip";
      }

      if (Item.status === "ANALYZING_FAILED") {
        ItemToPush.ErrorMessage = translateText(
          "analyzing_failed_error_message",
          props.LangData
        );
      } else if (
        Item.status === "UPLOADED" ||
        Item.status === "WAITING_FOR_UPLOAD"
      ) {
        ItemToPush.ErrorMessage = translateText(
          "successful_upload_text",
          props.LangData
        );
      } else if (Item.status === "INVALID_FILE_TYPE") {
        ItemToPush.ErrorMessage = translateText(
          "file_type_error_message",
          props.LangData
        );
      } else if (Item.status === "DUPLICATED_CONTENT") {
        ItemToPush.ErrorMessage = translateText(
          "duplicat_file_error_message",
          props.LangData
        );
      } else if (Item.status === "ANALYZED") {
        ItemToPush.ErrorMessage = translateText(
          "successful_upload_text",
          props.LangData
        );
      } else if (Item.status === "CONTAINS_ERROR_FILE") {
        ItemToPush.ErrorMessage = translateText(
          "damaged_file_error_message",
          props.LangData
        );
      } else if (Item.status === "FILE_SIZE_TOO_LARGE") {
        ItemToPush.ErrorMessage = translateText(
          "photo_uploader_validation_error_file_size",
          props.LangData
        );
      } else if (Item.status === "SERVER_ERROR") {
        ItemToPush.ErrorMessage = "Server error";
      }

      HistoryItems.push(ItemToPush);
    });
    createPagination(TotalCount);

    setFiles(HistoryItems);

    if (parseInt(document.getElementById("prev-start").value) !== Start) {
      uncheckAll(HistoryItems);
    }

    document.getElementById("prev-start").value = Start;

    setTotalElements(HistoryItems.length);
  };

  const bytesToMegaBytes = (bytes) => {
    return (bytes / 1024 ** 2).toFixed(2);
  };

  const startUpload = (FileItem, NewFilesArray, BinaryFilesArray, FileURL) => {
    // waiting for the upload bar to be through and giving the user time to decide if they want to
    // cancel the upload.
    setTimeout(() => {
      if (document.getElementById("upload-widget-" + 0 + "-modal") === null) {
        sendFileToAPI(FileItem, 0, NewFilesArray, BinaryFilesArray, FileURL);
      } else {
        TimerRef.current = setInterval(() => {
          if (
            TimerRef.current &&
            document.getElementById("upload-widget-" + 0 + "-modal") === null
          ) {
            clearInterval(TimerRef.current);
            if (!document.getElementById("upload-widget-" + 0 + "-cancelled")) {
              sendFileToAPI(
                FileItem,
                0,
                NewFilesArray,
                BinaryFilesArray,
                FileURL
              );
            } else {
              // in this case the user has accepted to cancell the upload
              return null;
            }
          }
        }, 1000);
      }
    }, 2500);
  };

  const sendFileToAPI = (
    FileItem,
    FileIndex,
    FilesList,
    BinaryFilesArray,
    FileURL
  ) => {
    onFileUpload(FileItem, FileIndex, FilesList, BinaryFilesArray, FileURL);
  };

  const onFileUpload = (
    FileItem,
    FileIndex,
    FilesList,
    BinaryFilesArray,
    FileURL
  ) => {
    setUploadIsOngoing(true);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/assistify/files",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      onUploadProgress: (progressEvent) => {
        const Progress = (progressEvent.loaded / progressEvent.total) * 100;
        let FilesList = [FileItem, ...Files];
        FilesList[0].percentage = Progress.toFixed();
        setFiles(FilesList);
      },
      data: {
        fileName: FileItem.name,
        status: "WAITING_FOR_UPLOAD",
        base64: FileURL,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);

        document.getElementById("input-file-upload").value = "";

        if (UploadIsOngoing) {
          setUploadIsOngoing(false);
        }

        let FilesList = [FileItem, ...Files];
        FilesList[0].percentage = 100;
        setFiles(FilesList);

        fetchHistory(false, 0, SelectedSize);
      })
      .catch((Err) => {
        console.log(Err.response);
        fetchHistory(false, 0, SelectedSize);
      });
  };

  const cancelItem = (Index) => {
    let Items = [...Files];
    Items[Index].status = "cancelled";
    setFiles(Items);
  };

  const saveFile = (FileItem, FileURL) => {
    setBinaryFiles([...BinaryFiles, FileItem]);
    let NewFile = {
      name: FileItem.name,
      lastModified: FileItem.lastModified,
      size: FileItem.size,
      type: FileItem.type,
      //   path: FileItem.path,
      status: "loading",
      percentage: 0,
    };

    let FileExtension = FileItem.name.slice(
      FileItem.name.indexOf("."),
      FileItem.name.length
    );
    if (
      FileExtension.toLowerCase() !== ".pdf" ||
      FileExtension.toLowerCase() !== ".docx" ||
      FileExtension.toLowerCase() !== ".png" ||
      FileExtension.toLowerCase() !== ".jpg" ||
      FileExtension.toLowerCase() !== ".jpeg"
    ) {
      NewFile.path = null;
    }
    let PrevItems;
    if (Files.length >= 5) {
      PrevItems = [...Files]
        .reverse()
        .splice([...Files].length - 4, [...Files].length);
    } else {
      PrevItems = [...Files].reverse();
    }
    let NewFilesArray = [...PrevItems, NewFile];
    setFiles(NewFilesArray.reverse());

    // validation of file size limit based on the extention (".zip" or an image file)
    if (FileExtension.toLowerCase() === ".zip") {
      if (
        parseInt(bytesToMegaBytes(NewFile.size)) > parseInt(SizeLimits.zipFile)
      ) {
        let Items = [...NewFilesArray];
        Items[0].status = "failed";
        Items[0].ErrorMessage = translateText(
          "photo_uploader_validation_error_file_size",
          props.LangData
        );
        createErrorForItem(Items[0]);
        setFiles(Items);
      } else {
        startUpload(
          NewFile,
          NewFilesArray,
          [...BinaryFiles, FileItem],
          FileURL
        );
        // setSuccessfulUploads(SuccessfulUploads + 1);

        setTotalElements(TotalElements + 1);
      }
    } else if (
      parseInt(NewFile.size * 0.001) > parseInt(SizeLimits.otherFile)
    ) {
      let Items = [...NewFilesArray];
      Items[0].status = "failed";
      Items[0].ErrorMessage = translateText(
        "photo_uploader_validation_error_file_size_single",
        props.LangData
      );
      createErrorForItem(Items[0]);
      setFiles(Items);
    } else {
      // file size validation passed:
      startUpload(NewFile, NewFilesArray, [...BinaryFiles, FileItem], FileURL);
    }
  };

  const createErrorForItem = (FileItem) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL + Config.AuthBaseURL + "/api/assistify/files",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        fileName: FileItem.name,
        size: FileItem.size,
        status: "FILE_SIZE_TOO_LARGE",
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const createPagination = (TotalCount) => {
    let Size;
    if (document.getElementById("pre-selected-row-per-page") !== null) {
      Size = parseInt(
        document.getElementById("pre-selected-row-per-page").innerHTML
      );
    } else {
      Size = SelectedSize;
    }
    let Count = Math.ceil(TotalCount / Size);
    let PagesArray = [];
    for (let i = 0; i < Count; i++) {
      PagesArray.push(i + 1);
    }
    setPages(PagesArray);
    shortenPagination(PagesArray);
  };

  const shortenPagination = (Pages) => {
    if (Pages.length > 0) {
      let LastPage = Pages.reduce((a, b) => {
        return Math.max(a, b);
      });
      let FirstPage = parseInt(Pages[0]);
      let MiddlePage = 3;
      let FirstDotsShown = false;
      let LastDotsShown = true;
      let ActivePage;

      for (let i = 1; i <= Pages.length; i++) {
        if (document.getElementById(i + "-page-btn") !== null) {
          if (
            document
              .getElementById(i + "-page-btn")
              .classList.contains("active-page")
          ) {
            ActivePage = i;
          }
        }
      }
      if (ActivePage < 3) {
        LastDotsShown = true;
      }
      if (ActivePage > 3) {
        FirstDotsShown = true;
        MiddlePage = ActivePage;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      if (ActivePage < MiddlePage && ActivePage > 3) {
        FirstDotsShown = true;
        LastDotsShown = true;
      }
      if (parseInt(LastPage - 3) >= ActivePage) {
        LastDotsShown = false;
      }
      if (ActivePage === 3) {
        FirstDotsShown = false;
        MiddlePage = 3;
        setTimeout(() => {
          updateActiveClass(MiddlePage);
        }, 50);
      }
      setPageInfo({
        FirstPage: FirstPage,
        FirstDotsShown: FirstDotsShown,
        MiddlePage: MiddlePage,
        LastDotsShown: LastDotsShown,
        LastPage: LastPage,
        ActivePage: ActivePage,
      });
    } else {
      setPageInfo({
        FirstPage: 1,
        FirstDotsShown: false,
        MiddlePage: 3,
        LastDotsShown: true,
        LastPage: 1,
        ActivePage: 1,
      });
    }
  };
  const updatePaginationlength = (PageNum) => {
    shortenPagination(Pages);
    if (PageNum === PageInfo.LastPage) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
    } else {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
    }
  };

  const displayTime = (UploadDate) => {
    var Hours = new Date(UploadDate).getHours();
    if (Hours < 10) {
      Hours = "0" + Hours;
    }
    var Minutes = new Date(UploadDate).getMinutes();
    if (Minutes < 10) {
      Minutes = "0" + Minutes;
    }
    return Hours + ":" + Minutes;
  };

  const updateActiveClass = (PageNumber) => {
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        document
          .getElementById(i + "-page-btn")
          .classList.remove("active-page");
      }
    }
    document
      .getElementById(PageNumber + "-page-btn")
      .classList.add("active-page");
  };
  const requestNextPage = () => {
    let NextPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          NextPage = parseInt(i + 1);
        }
      }
    }
    if (document.getElementById(NextPage + "-page-btn") !== null) {
      document.getElementById(NextPage + "-page-btn").click();
    }
  };
  const requestPrevPage = () => {
    let PrevPage;
    for (let i = 1; i <= Pages.length; i++) {
      if (document.getElementById(i + "-page-btn") !== null) {
        if (document.getElementById(i + "-page-btn").classList.length > 1) {
          if (i === 1) {
            PrevPage = 1;
          } else {
            PrevPage = parseInt(i - 1);
          }
        }
      }
    }
    if (document.getElementById(PrevPage + "-page-btn") !== null) {
      document.getElementById(PrevPage + "-page-btn").click();
    }
  };

  const requestPageNumber = (PageNumber) => {
    setActivePage(PageNumber);
    let Size = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    let NewStart = parseInt((PageNumber - 1) * Size);

    fetchHistory(false, NewStart, Size);

    if (NewStart === 0) {
      document.getElementById("start").innerHTML = 1;
    } else {
      document.getElementById("start").innerHTML = NewStart + 1;
    }
    if (parseInt(document.getElementById("end").innerHTML) === TotalElements) {
      document.getElementById("next-page").classList.add("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    } else {
      document.getElementById("end").innerHTML = parseInt(NewStart + Size);
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document
        .getElementById("prev-page")
        .classList.remove("page-btn-disabled");
    }
    if (PageNumber === 1) {
      document
        .getElementById("next-page")
        .classList.remove("page-btn-disabled");
      document.getElementById("prev-page").classList.add("page-btn-disabled");
    }
    updateActiveClass(PageNumber);
    updatePaginationlength(PageNumber);
  };
  const setSize = () => {
    let SelectedSize = parseInt(
      document.getElementById("pre-selected-row-per-page").innerHTML
    );
    setSelectedSize(SelectedSize);
    setTimeout(() => {
      if (document.getElementById("1-page-btn") !== null) {
        document.getElementById("1-page-btn").click();
      }
    }, 300);
  };

  const toggleExtract = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/assistify/files/analyze",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        ids: CheckedItems,
      },
    };
    if (CheckedItems.length === 0) {
      setModalIsOpen(true);
    } else {
      setExtractInProgress(true);
      uncheckAll(Files);
      axios(Req)
        .then((Res) => {
          console.log(Res);
          requestPageNumber(ActivePage);
        })
        .catch((Err) => {
          console.log(Err);
          setExtractInProgress(false);
        });
    }
  };

  const resetSeacrh = () => {
    document.getElementById("clear-btn").click();
  };

  const toggleDeleteItem = (FileInfo) => {
    setDeleteIsOpen(true);
    setFileToDelete(FileInfo);
  };

  const cancelDelete = () => {
    setFileToDelete(undefined);
    setDeleteIsOpen(false);
  };

  const saveCheckedItems = (Checked) => {
    setCheckedItems(Checked);
  };

  const handleSelectAll = (SelectAllIsActive) => {
    var AllIDs = [];
    var Checked = [];

    Files.map((Item) => {
      AllIDs.push(Item.id);
    });

    AllIDs.map((ID) => {
      document.getElementById("checkbox-" + ID).checked = true;

      if (!document.getElementById("checkbox-" + ID).disabled) {
        Checked.push(ID);
      }
    });

    if (SelectAllIsActive) {
      uncheckAll(Files);
    } else {
      setCheckedItems(Checked);
    }
    setSelectIsActive(!SelectIsActive);
  };

  const requestDelete = (FileId) => {
    if (!FileId) {
      FileId = FileToDelete.id;
    }
    let Req = {
      method: "DELETE",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/assistify/files/" +
        FileId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
        setDeleteIsOpen(false);
        setFileToDelete(undefined);
        requestPageNumber(1);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const toggleSearch = () => {
    uncheckAll(Files);
    fetchHistory(false, 0, SelectedSize);
  };

  const toggleDownloadFile = (FileId, FileName) => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/assistify/files/" +
        FileId,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      responseType: "arraybuffer", // Set the responseType to arraybuffer
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);

        let URL = window.URL.createObjectURL(
          new Blob([Res.data], { type: "application/octet-stream" })
        );
        let Link = document.createElement("a");
        Link.href = URL;
        Link.setAttribute("download", FileName);
        document.body.appendChild(Link);
        Link.click();
        setTimeout(() => {
          document.body.removeChild(Link);
        }, 500);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <div className="main-content security-settings ai">
      <input hidden id="prev-start" />
      {ModalIsOpen ? (
        <Alert
          cancel={() => setModalIsOpen(false)}
          AlertText={translateText("action_required", props.LangData)}
          AlertInfo={translateText("assistify_modal_text", props.LangData)}
          BodyClassName={"long-alert-body"}
          CancelIsHidden
          accept={() => setModalIsOpen(false)}
          PrimaryBtnClassName="primary-blue-btn blue-btn"
          AcceptText={translateText(
            "assistify_modal_button_text",
            props.LangData
          )}
        />
      ) : null}
      <ContentHeader PageName={translateText("assistify", props.LangData)} />
      <div className="content-header">
        <div className="address">
          <p>{translateText("data_import", props.LangData)}</p>
          <img src={Circle} alt="." />
          <p>{translateText("assistify", props.LangData)}</p>
        </div>
      </div>
      <div className="simple-form assistify">
        {DeleteIsOpen ? (
          <Alert
            IsDelete
            LangData={props.LangData}
            cancelDelete={() => cancelDelete()}
            acceptDelete={() => requestDelete()}
          />
        ) : null}
        <section className="form-head">
          <h1>{translateText("assistify", props.LangData)}</h1>
        </section>
        <main className="form-body">
          <p className="files-wrapper-title">
            {SuccessfulUploads} {translateText("of", props.LangData)}{" "}
            {AllFilesCount}{" "}
            {translateText("files_uploaded_successfully", props.LangData)}
          </p>
          <UploadZone
            LangData={props.LangData}
            SaveFile={(FileItem, FileURL) => saveFile(FileItem, FileURL)}
          />
          <div className="form-body-head">
            <SearchInput
              OnChange={() => toggleSearch()}
              Placeholder={translateText("search_files", props.LangData)}
            />
            {ExtractInProgress ? (
              <button className="extract-btn">
                <img src={Rotator} />
              </button>
            ) : (
              <>
                {DeleteIsOpen ? (
                  <button className="extract-btn disabled">
                    {translateText("extract_and_analyze", props.LangData)}
                  </button>
                ) : (
                  <button
                    className="extract-btn"
                    onClick={() => toggleExtract()}
                  >
                    {translateText("extract_and_analyze", props.LangData)}
                  </button>
                )}
              </>
            )}
          </div>
          {Files.length > 0 ? (
            <div className="uploaded-files">
              <span
                className="bule-action-text"
                onClick={() => handleSelectAll(SelectIsActive)}
              >
                {SelectIsActive
                  ? translateText("unselect_all", props.LangData)
                  : translateText("select_all", props.LangData)}
              </span>
              {[...Files].map((Item, i) => (
                <UploadWidget
                  Id={"upload-widget-" + i}
                  Name={Item.name}
                  AllFiles={Files}
                  Progress={Item.percentage ? Item.percentage : 0}
                  Status={Item.status}
                  LangData={props.LangData}
                  Size={bytesToMegaBytes(Item.size)}
                  ToggleDelete={() => toggleDeleteItem(Item)}
                  RequestDeleteItem={(FileId) => requestDelete(FileId)}
                  ErrorMessage={Item.ErrorMessage}
                  InfoMessage={Item.InfoMessage}
                  FileId={Item.id}
                  Type={Item.type}
                  SizeLimits={SizeLimits}
                  SaveCheckedItems={(Checked) => saveCheckedItems(Checked)}
                  ToggleDownload={() => toggleDownloadFile(Item.id, Item.name)}
                  UploadDateTime={
                    Item.updatedTime
                      ? formatDate(Item.updatedTime) +
                        ", " +
                        displayTime(Item.updatedTime)
                      : ""
                  }
                  CancelUpload={() => cancelItem(i)}
                />
              ))}
            </div>
          ) : (
            <>
              {InitialLoadIsDone ? (
                <FormEmptyState
                  Message={
                    "There are no files that match the searched file name."
                  }
                  ResetFilters={() => resetSeacrh()}
                />
              ) : null}
            </>
          )}
          <>
            {Files.length > 0 ? (
              <div className="content-pagination" id="info-footer">
                <div className="pagenumber-summary">
                  {translateText("showing", props.LangData)} <p id="start">1</p>
                  {translateText("to", props.LangData)} <p id="end">3</p>
                  {translateText("of", props.LangData)} {TotalElements}{" "}
                  {translateText("items", props.LangData)}.
                </div>
                <section className="pagination-holder">
                  <button
                    onClick={() => requestPrevPage()}
                    id="prev-page"
                    className={
                      Pages.length < 6
                        ? "page-btn page-btn-disabled right-margined"
                        : "page-btn page-btn-disabled"
                    }
                  >
                    <i className="feather-chevron-left"></i>
                  </button>
                  <React.Fragment>
                    {Pages.length < 6 ? (
                      <React.Fragment>
                        {Pages.map((Page) => (
                          <React.Fragment>
                            {Page === 1 ? (
                              <button
                                key={Page}
                                onClick={() => requestPageNumber(Page)}
                                className="page-btn active-page"
                                id={Page + "-page-btn"}
                              >
                                {Page}
                              </button>
                            ) : (
                              <button
                                key={Page}
                                onClick={() => requestPageNumber(Page)}
                                className="page-btn"
                                id={Page + "-page-btn"}
                              >
                                {Page}
                              </button>
                            )}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <button
                          onClick={() => requestPageNumber(1)}
                          className="page-btn active-page"
                          id={1 + "-page-btn"}
                        >
                          {1}
                        </button>
                        {PageInfo.FirstDotsShown ? <p>...</p> : null}
                        <button
                          onClick={() =>
                            requestPageNumber(parseInt(PageInfo.MiddlePage - 1))
                          }
                          className="page-btn"
                          id={parseInt(PageInfo.MiddlePage - 1) + "-page-btn"}
                        >
                          {parseInt(PageInfo.MiddlePage - 1)}
                        </button>
                        {PageInfo.MiddlePage === PageInfo.LastPage ? null : (
                          <button
                            onClick={() =>
                              requestPageNumber(PageInfo.MiddlePage)
                            }
                            className="page-btn"
                            id={PageInfo.MiddlePage + "-page-btn"}
                          >
                            {PageInfo.MiddlePage}
                          </button>
                        )}
                        {parseInt(PageInfo.MiddlePage + 1) >=
                        PageInfo.LastPage ? null : (
                          <button
                            onClick={() =>
                              requestPageNumber(
                                parseInt(PageInfo.MiddlePage + 1)
                              )
                            }
                            className="page-btn "
                            id={parseInt(PageInfo.MiddlePage + 1) + "-page-btn"}
                          >
                            {parseInt(PageInfo.MiddlePage + 1)}
                          </button>
                        )}
                        {!PageInfo.LastDotsShown ? <p>...</p> : null}
                        <button
                          onClick={() => requestPageNumber(PageInfo.LastPage)}
                          className="page-btn"
                          id={PageInfo.LastPage + "-page-btn"}
                        >
                          {PageInfo.LastPage}
                        </button>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                  <button
                    onClick={() => requestNextPage()}
                    id="next-page"
                    className={
                      Pages.length < 6 ? "page-btn left-margined" : "page-btn"
                    }
                  >
                    <i className="feather-chevron-right"></i>
                  </button>
                </section>
                <div className="row-count-select">
                  <p className="row-info">
                    {translateText("items_per_page", props.LangData)}
                  </p>
                  <Select
                    Initial={"5"}
                    Options={SizeOptions}
                    IsWithId
                    PreSelectedId={"5"}
                    Id={"row-per-page"}
                    ChangeHandler={() =>
                      setTimeout(() => {
                        setSize();
                      }, 100)
                    }
                    ValidationError=""
                  />
                </div>
              </div>
            ) : null}
          </>
        </main>
        <section className="footer-hint">
          <i className="feather-info"></i>
          <p>
            {translateText("file_upload_info_1", props.LangData)}{" "}
            {SizeLimits.zipFile} MB{" "}
            {translateText("file_upload_info_2", props.LangData).toLowerCase()}{" "}
            {SizeLimits.otherFile} KB.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Assistify;
